import React from "react";
export function InvoiceStatusFormatter(
    row: any,
){
    return <span className={`badge ${row === 0 ? 'badge-danger' : 'badge-success'}`}>
        {row === 0 ? 'پرداخت نشده' : 'پرداخت شده'}
    </span>
}